import React from "react";
import {
  AiOutlineAppstore,
  AiOutlineEnvironment,
  AiOutlineInfoCircle,
} from "react-icons/ai";
import { Link } from "react-router-dom";
import JobCell from "./JobCell";
import { getCompanyImageById } from "constant/jobs";

const JobCard = ({ job }) => {
  const {
    companyName,
    companyID,
    industry,
    positionTitle,
    location,
    type,
    id,
  } = job;

  const companyImage = getCompanyImageById(companyID);

  return (
    <Link to={`/job-expo/${id}`} key={id}>
      <div
        className="bg-wce-neutral-1 py-4 sm:py-8 px-4 sm:px-10 flex rounded-3xl w-full gap-6
          hover:shadow-wce-job cursor-pointer"
      >
        <div className="min-w-[100px] w-[100px] hidden sm:block">
          <img
            src={companyImage}
            alt="logo"
            className="w-[100px] h-[100px] object-contain"
          />
        </div>
        <div className="flex flex-col gap-1 sm:gap-2 w-full">
          <div className="flex gap-4">
            <div className="min-w-[56px] w-[56px] block sm:hidden">
              <img
                src={companyImage}
                alt="logo"
                className="w-[56px] h-[56px] object-contain"
              />
            </div>
            <div>
              <div className="font-medium text-sm sm:text-xl text-wce-neutral-10">
                {positionTitle}
              </div>
              <div className="text-wce-neutral-9 text-sm sm:text-base">
                {companyName}
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:grid sm:grid-cols-job w-full mt-1 sm:mt-0 gap-1 sm:gap-4 ">
            <JobCell
              icon={AiOutlineAppstore}
              content={industry}
              isDetail={false}
            />
            <JobCell
              icon={AiOutlineEnvironment}
              content={location}
              isDetail={false}
            />
            <JobCell
              icon={AiOutlineInfoCircle}
              content={type}
              isDetail={false}
            />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default JobCard;
